<template>
    <div class="plugin-details">
        <PluginItem :infos="props.plugin" :provider="props.provider" :category="props.category"></PluginItem>
        <div class="long-desc" v-html="props.plugin.description"></div>
        <div class="tags">
            <div class="frequency" v-if="props.plugin.cron">
                <font-awesome-icon icon="sync-alt" fixed-width></font-awesome-icon><!--
                --><span>{{ cronToReadable }}</span>
            </div>
            <div class="price">
                <font-awesome-icon icon="euro-sign" fixed-width></font-awesome-icon><!--
                --><span>Gratuit</span>
            </div>
        </div>
        <div class="bottom-container">
            <Btn class="success block" @click.native="handlePluginAdd" v-if="requiredPluginsOK && props.plugin.availability === 0">
                <font-awesome-icon icon="plus"></font-awesome-icon> Ajouter ce plugin
            </Btn>
            <div class="required-not-ok" v-else>
                <template v-if="props.plugin.availability === 1">
                    <font-awesome-icon icon="exclamation-triangle"></font-awesome-icon>
                    <div>
                        Ce connecteur ou un autre connecteur incompatible avec celui-ci est déjà installé
                    </div>
                </template>
                <template v-else>
                    <font-awesome-icon icon="exclamation-triangle"></font-awesome-icon>
                    <div>
                        Ce connecteur nécessite que
                        <template v-if="requiredPlugins.length > 1">
                            les connecteurs <em>{{ requiredPlugins | arrayToString }}</em> soient configurés et activés
                        </template>
                        <template v-else>
                            le connecteur <em>{{ requiredPlugins | arrayToString }}</em> soit configuré et activé
                        </template>
                        pour être ajouté
                    </div>
                </template>

            </div>
            <!--<a href="https://client.suivideflotte.net" target="_blank" class="doc-link">
                <font-awesome-icon icon="question-circle"></font-awesome-icon> Voir la documentation des prérequis
            </a>-->
        </div>
    </div>
</template>

<script>
    //import Component from 'path/to/component'
    import {mapMutations} from 'vuex'

    import _find from 'lodash/find'

    import PluginItem from '@c/plugins/library/PluginItem'
    import cronstrue from 'cronstrue/dist/cronstrue-i18n'

    export default {
        beforeCreate: function () {

        },
        beforeDestroy: function () {

        },
        beforeMount: function () {

        },
        beforeUpdate: function () {

        },
        components: {
            PluginItem
        },
        computed: {
            cronToReadable(){
                return cronstrue.toString(this.props.plugin.cron, { locale: "fr" });
            },
            requiredPluginsOK(){
                let OK = true
                if(this.props.plugin.require.length > 0){

                    this.props.plugin.require.forEach(item => {

                        let configs = _find(this.props.configurations,config => {
                            //console.log(item,config.plugin.pluginId,config.is_active,config.plugin.pluginId === item && config.is_active === true)
                            return config.plugin.pluginId === item && config.is_active === true
                        })

                        //console.warn(!configs)

                        if(!configs){
                            OK = false
                        }
                    })

                }
                return OK
            },
            requiredPlugins(){

                let names = []

                if(this.props.plugin.require.length > 0){

                    this.props.plugin.require.forEach(item => {

                        let configs = _find(this.props.configurations,config => {
                            //console.log('NAMES',item,config.plugin.pluginId,config.is_active,config.plugin.pluginId === item && config.is_active === false)
                            return config.plugin.pluginId === item && config.is_active === false
                        })

                        //console.log(configs)

                        if(configs){
                            names.push(configs.plugin.name)
                        }
                    })

                }

                //console.log(names)

                return names
            }
        },
        created: function () {

        },
        data() {
            return {}
        },
        destroyed: function () {

        },
        methods: {
            ...mapMutations({
                handleCloseModal: 'UI/closeModal'
            }),

            handlePluginAdd(){
                this.$router.push({name:'pluginNew',params: {id: this.props.plugin.pluginId}})
                setTimeout(() => {
                    this.handleCloseModal()
                },500)

            }

        },
        mounted: function () {

        },
        name: '',
        props: {
            props: {
                type: Object,
                validator(value){
                    return value.plugin != null && value.provider != null && value.category != null && value.configurations != null
                }
            }
        },
        updated: function () {

        },
        watch: {}
    }
</script>

<style lang="scss">
    .plugin-details{
        .plugin{
            box-shadow: none;
            padding: 0;
            cursor: default;
            margin-bottom: 20px;

            .state{
                flex: 0 0 0;
            }
        }

        .long-desc{
            margin-bottom: 20px;
            padding: 0 1.65em;
        }

        .tags{
            margin-bottom: 20px;
            line-height: 24px;

            .svg-inline--fa{
                margin-right: 0.4em;
            }
        }

        .bottom-container{

            width: 80%;
            margin: 0 auto;

            .button{
                text-transform: uppercase;
            }

            .required-not-ok{
                background-color: rgba($warning,0.2);
                border: solid 2px $warning;
                color: $warning;
                font-weight: $semi-bold;
                padding: 10px;
                display: flex;
                align-items: center;

                .svg-inline--fa{
                    font-size: 1.7rem;
                    margin-right: 10px;
                }

                em{
                    font-weight: $bold;
                }
            }

            .doc-link{
                color: $main-color;
                display: block;
                text-align: center;
                text-decoration: none;
                line-height: 30px;
                margin-top: 10px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/plugins/library/PluginDetails.vue